export const DEFAULT_PRODUCT_POLICIES = {
  shippingTitle: '',
  shippingDescription: '',
  shippingCost: '',
  deliveryTitle: '',
  deliveryDescription: '',
  deliveryCost: '',
  warrantyTitle: '',
  warrantyDescription: '',
  returnTitle: '',
  returnDescription: ''
};

export const withDefaultProductPolicies = (product = {}) => ({
  ...DEFAULT_PRODUCT_POLICIES,
  ...product
});
